import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

export default angular.module('fukuichuoKankoApp.main', [uiRouter])
  .config(routing)
  .component('main', {
    template: require('./main.html'),
    controller: ['$http',
      function MainController($http) {
        var that = this;

        that.getType = function getType(busType) {
          that.busSectionBusses = busType;
        };

        $http.get('data/busses.json').then(function(response) {
          that.busses = response.data;
          that.getType(that.busses.bigBus);
        });
      }
    ]
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js